import { EventBus } from "@/eventBus";
import { createLogger } from "@/utils/logger";

const logger = createLogger("userLogger");

function safeSerialize(value) {
  const seen = new WeakSet();

  try {
    return JSON.stringify(value, (key, currentValue) => {
      if (typeof currentValue === "function") {
        return `[Function ${currentValue.name || "anonymous"}]`;
      }

      if (currentValue instanceof Error) {
        return {
          name: currentValue.name,
          message: currentValue.message,
          stack: currentValue.stack,
        };
      }

      if (currentValue && currentValue._isVue) {
        return "[VueInstance]";
      }

      if (typeof Element !== "undefined" && currentValue instanceof Element) {
        return {
          tagName: currentValue.tagName,
          id: currentValue.id || null,
          className: currentValue.className || null,
        };
      }

      if (currentValue && typeof currentValue === "object") {
        if (seen.has(currentValue)) {
          return "[Circular]";
        }

        seen.add(currentValue);
      }

      return currentValue;
    });
  } catch (error) {
    logger.warn("Failed to serialize logger payload", error);
    return JSON.stringify({
      serializationError: error.message,
    });
  }
}

function clickListener(event) {
  const target = event.target;
  const elementInfo = target.innerText?.trim().substring(0, 20) || target.id || target.tagName;
  const type = `[UI CLICK] ${elementInfo}`;
  const data = safeSerialize({
    tag: target.tagName,
    id: target.id || null,
    classes: target.className || null,
  });

  EventBus.$emit("send-log-data", type, data);
}

export default {
  unsubscribe: null,
  ignoreActions: ["setEmployeeData", "i18n/addLocale"],
  install(store) {
    if (!store || this.unsubscribe) {
      return;
    }

    window.addEventListener("click", clickListener);
    this.unsubscribe = store.subscribeAction({
      before: (action) => {
        if (this.ignoreActions.includes(action.type)) {
          return;
        }

        EventBus.$emit("send-log-data", `[EVENT START] ${action.type}`, safeSerialize({
          action: {
            type: action.type,
            payload: action.payload,
          },
        }));
      },
      after: (action) => {
        if (this.ignoreActions.includes(action.type)) {
          return;
        }

        EventBus.$emit("send-log-data", `[EVENT SUCCESS] ${action.type}`, safeSerialize({
          action: {
            type: action.type,
            payload: action.payload,
          },
        }));
      },
      error: (action, storeState, error) => {
        if (this.ignoreActions.includes(action.type)) {
          return;
        }

        void storeState;
        EventBus.$emit("send-log-data", `[EVENT ERROR] ${action.type}`, safeSerialize({
          action: {
            type: action.type,
            payload: action.payload,
          },
          error,
        }));
      },
    });
  },
  remove() {
    window.removeEventListener("click", clickListener);

    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
    }
  },
};
